import {
  InstagramIcon,
  FacebookIcon,
  WhatsAppIcon,
  TelegramIcon,
  TwitterIcon,
  TikTokIcon,
  SnapchatIcon,
  OtherSocialIcon
} from "assets/icons";
import { Icon } from "ui";

import { SharingSocials } from "../../constants";
import { SocialIconProps } from "./SocialIcon.types";

const SocialIcon = ({ social, size = 20 }: SocialIconProps) => {
  switch (social) {
    case SharingSocials.Instagram:
      return <Icon as={InstagramIcon} boxSize={size} />;
    case SharingSocials.Facebook:
      return <Icon as={FacebookIcon} boxSize={size} />;
    case SharingSocials.WhatsApp:
      return <Icon as={WhatsAppIcon} boxSize={size} />;
    case SharingSocials.TikTok:
      return <Icon as={TikTokIcon} boxSize={size} />;
    case SharingSocials.Snapchat:
      return <Icon as={SnapchatIcon} boxSize={size} />;
    case SharingSocials.Telegram:
      return <Icon as={TelegramIcon} boxSize={size} />;
    case SharingSocials.Twitter:
      return <Icon as={TwitterIcon} boxSize={size} />;
    default:
      return <Icon as={OtherSocialIcon} boxSize={size} />;
  }
};

export default SocialIcon;
